import { store } from '../../../../store.js';

const MORTGAGE_PRICE_PER_USER = 27.5;
const MORTGAGE_EXTRA_ZONE_PRICE = 126.5;
const MORTGAGE_NATIONAL_ZONE_PRICE = 231.0;

const OTHERS_PRICE_PER_USER = 44.0;
const OTHERS_EXTRA_ZONE_PRICE = 115.5;
const OTHERS_NATIONAL_ZONE_PRICE = 209.0;

const PROPERTY_NATIONAL_ZONE_PRICE = 66.0;

const EXTRA_ZONE_QUANTITY = 12;
const NATIONAL_ZONE_QUANTITY = 12;

const handleName = (packageName, userCount, isNational) => {
  return `${packageName} - ${userCount} ${userCount > 1 ? 'Users' : 'User'} - ${
    isNational ? 'National' : '1 Zone'
  }`;
};

const getPrice = (industry, productPackage, discountPercentage) => {

  const { productsConfig } = store.getState().packageSelection;
  const price = productsConfig['rp-data-professional'].configuration.industries[industry].packages[productPackage].base_price;
  if(discountPercentage){
    const discountPrice = price * discountPercentage;
    const totalPrice = Math.round((price - discountPrice)* 100) / 100
    return totalPrice
  }else {
    return price
  }
};

const handleExtraUser = (
  productList,
  product,
  packageName,
  userCount,
  defaultUserCount,
  pricePerUser,
  minimumInitialTerm
) => {
  if (userCount > defaultUserCount) {
    const extraUserCount = userCount - defaultUserCount;

    product.item_id = product.item_name = `${packageName} - Add On - Extra User`;
    if(product.discountPercentage){
      const discountPrice = pricePerUser * product.discountPercentage;
      const totalPrice = Math.round((pricePerUser  - discountPrice)* 100) / 100
      product.price = totalPrice;
    }else {
      product.price = pricePerUser;
    }
    product.quantity = minimumInitialTerm * extraUserCount;
    productList.push({ ...product });
  }
};

const handleExtraZone = (
  productList,
  product,
  packageName,
  isNational,
  states,
  extraZonePrice,
  nationalZonePrice
) => {
  if (isNational || states.length > 1) {
    // extra zone yes for national || 2 zones
    product.item_id = product.item_name = `${packageName} - Add On - Extra Zone`;
    if(product.discountPercentage){
      const discountPrice = (isNational ? nationalZonePrice : extraZonePrice) * product.discountPercentage;
      const totalPrice = Math.round(((isNational ? nationalZonePrice : extraZonePrice) - discountPrice)* 100) / 100
      product.price = totalPrice;
    }else {
      product.price = isNational ? nationalZonePrice : extraZonePrice;
    }
    product.quantity = isNational ? NATIONAL_ZONE_QUANTITY : EXTRA_ZONE_QUANTITY;
    productList.push({ ...product });
  }
};

const handleAddons = (productList, product, addons, packageName, minimumInitialTerm) => {
  if (addons.length > 0) {
    addons.map((addon) => {
      product.item_id = product.item_name = `${packageName} - Add On - ${addon.description}`;
      if(product.discountPercentage){
        const discountPrice = addon.total * product.discountPercentage;
        const totalPrice = Math.round((addon.total - discountPrice)* 100) / 100
        product.price = totalPrice;
      }else {
        product.price = addon.total;
      }
      product.quantity = minimumInitialTerm;
      productList.push({ ...product });
    });
  }
};

const handleRppConfig = (quote, quoteConfig, category) => {
  const { addons, headLine: packageName, minimumInitialTerm, totalPerMonth } = quote;
  const {
    industry,
    geography,
    number_of_users: userCount,
    package: productPackage
  } = quoteConfig.configuration;

  let product = {};
  const productList = [];

  let defaultUserCount = 1;

  // Default Values
  product.item_brand = 'RP Data';
  product.item_category = category;
  product.item_variant = packageName;
  product.coupon = null;
  product.discountPercentage = quote.provisioningInfo?.discountPercentage
    ? quote.provisioningInfo?.discountPercentage / 100
    : null;

  if (industry === 'real_estate_agencies_and_valuers') {
    product.item_id = product.item_name = handleName(packageName, userCount, geography.national);
    // get base price from config above order
    if(product.discountPercentage){
      const discountPrice = totalPerMonth * product.discountPercentage;
      product.price = Math.round((totalPerMonth - discountPrice)* 100) / 100
    }else{
      product.price = totalPerMonth;
    }

    product.quantity = minimumInitialTerm;
    product.item_category2 = minimumInitialTerm.toString();
    product.item_category3 = geography.national ? 'National' : geography.states?.join(', ');

    productList.push({ ...product });
  } else if (industry === 'mortgage_brokers_and_financial_planners') {
    if (productPackage === 'pro') {
      defaultUserCount = 2;
    }

    product.item_id = product.item_name = handleName(packageName, defaultUserCount, geography.national);
    product.price = getPrice(industry, productPackage, product.discountPercentage);
    product.quantity = minimumInitialTerm;
    product.item_category2 = minimumInitialTerm.toString();
    product.item_category3 = geography.national ? 'National' : geography.states?.join(', ');

    productList.push({ ...product });

    // Handle Extra User (compare to defaultUserCount)
    handleExtraUser(
      productList,
      product,
      packageName,
      userCount,
      defaultUserCount,
      MORTGAGE_PRICE_PER_USER,
      minimumInitialTerm
    );

    // Handle Extra Zone - only available for pro on Mortgage
    if (productPackage === 'pro') {
      handleExtraZone(
        productList,
        product,
        packageName,
        geography.national,
        geography.states,
        MORTGAGE_EXTRA_ZONE_PRICE,
        MORTGAGE_NATIONAL_ZONE_PRICE
      );
    }

    // Handle Add On
    handleAddons(productList, product, addons, packageName, minimumInitialTerm);
  } else if (industry === 'investors') {
    product.item_id = product.item_name = `${packageName} - 1 User - ${geography.national ? 'National' : '1 Zone'}`;
    product.price = getPrice(industry, productPackage, product.discountPercentage);
    if (geography.national) product.price = product.price + PROPERTY_NATIONAL_ZONE_PRICE;
    product.quantity = minimumInitialTerm;
    product.item_category2 = minimumInitialTerm.toString();
    product.item_category3 = geography.national ? 'National' : geography.states?.join(', ');

    productList.push({ ...product });

    // Handle Add On
    handleAddons(productList, product, addons, packageName, minimumInitialTerm);
  } else if (industry === 'property_developers_trades_services') {
    product.item_id = product.item_name = handleName(packageName, defaultUserCount, geography.national);
    product.price = getPrice(industry, productPackage, product.discountPercentage);
    product.quantity = minimumInitialTerm;
    product.item_category2 = minimumInitialTerm.toString();
    product.item_category3 = geography.national ? 'National' : geography.states?.join(', ');

    productList.push({ ...product });

    // Handle Extra User (compare to defaultUserCount)
    handleExtraUser(
      productList,
      product,
      packageName,
      userCount,
      defaultUserCount,
      OTHERS_PRICE_PER_USER,
      minimumInitialTerm
    );

    // Handle Extra Zone
    handleExtraZone(
      productList,
      product,
      packageName,
      geography.national,
      geography.states,
      OTHERS_EXTRA_ZONE_PRICE,
      OTHERS_NATIONAL_ZONE_PRICE
    );

    // Handle Add On
    handleAddons(productList, product, addons, packageName, minimumInitialTerm);
  }
  return productList;
};

export { handleRppConfig };
